import { EWidgetRegion } from '../enums';

export const WIDGET_REGIONS: EWidgetRegion[] = [
  EWidgetRegion.Left,
  EWidgetRegion.Center,
  EWidgetRegion.Right,
];
